<template>
  <footer><br>
    <div
      class="card-footer align-center mx-auto"
      style="min-height:100px; width:100%; border: none;"
    >
      <div class="d-flex justify-content-between">
        <div class>
          Do you like BRAND?
          <span class="text-danger">Advertise with us</span>
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <p>Developed by: &nbsp;</p>
          </div>
          <div class="text-danger">
            <p>David Armijos</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>